import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import Select from "react-select";
import validator from "validator";
import { boundaryContext } from "../../../../App";
import { ReactComponent as BoardIcon } from "../../../../components/assets/List_view_icon.svg"; // Import your custom SVG icon
import { ReactComponent as ListIcon } from "../../../../components/assets/board_view_icon.svg"; // Import a different icon for checked state
import high from "../../../../components/assets/high_priority.svg";
import low from "../../../../components/assets/low_priority.svg";
import normal from "../../../../components/assets/normal_priority.svg";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../../../components/axiosClient";
import LoadingSpinner from "../../../../components/loader/LoadingSpinner";
import {
  errorNotification,
  successNotification,
} from "../../../../components/toast-notification/common-toast";
import {
  ADD_PROJECT_TASK_STATUS,
  CREATE_TASK,
  DELETE_PROJECT_TASK_STATUS,
  DELETE_TASK_BY_ID,
  GET_PROJECT_MEMBERS,
  GET_PROJECT_TASK_STATUS,
  GET_TASKS,
  MANAGE_PROJECT_TASK_STATUS_INDEX,
  UPDATE_PROJECT_TASK_STATUS,
  UPDATE_TASK,
} from "../../../../components/utils";
import Modal from "../../Modal/Modal";
import NewModal from "../../Modal/NewModal";
import TaskListKanban from "./TaskListKanban";
import TaskListView from "./TaskListView";
import { ReactComponent as Configuration_icon } from "../../../../components/assets/configuration_icon.svg";
import { Tooltip } from "@mui/material";
import CommonDatePicker from "../../../CommonDatePicker";
import DragPopup from "./DragPopup";
import { priorityOptions } from "../../../../components/common/const";

const TaskList = ({ projectId }) => {
  const [firstLoading, setFirstLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDragPopupOpen, setIsDragPopupOpen] = useState(false);
  const [taskData, setTaskData] = useState({
    title: "",
    assigned_to: null,
    assigned_by: null,
    due_date: null,
    priority: null,
    description: null,
    project_id: projectId,
    status: "To do",
  });
  const [taskList, setTaskList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [filterMemberList, setFilterMemberList] = useState([]);
  const [columnTitles, setColumnTitles] = useState([]);

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { boardView, setBoardView } = useContext(boundaryContext);

  const assignedToFilterParams = searchParams.get("assigned_to");
  const [assignedToFilter, setAssignedToFilter] = useState(
    assignedToFilterParams ? parseInt(assignedToFilterParams) : null
  );

  const createdByFilterParams = searchParams.get("assigned_by");
  const [createdByFilter, setCreatedByFilter] = useState(
    createdByFilterParams ? parseInt(createdByFilterParams) : null
  );

  const priorityParams = searchParams.get("priority");
  const [priorityFilter, setPriorityFilter] = useState(
    priorityParams ? priorityParams : null
  );

  const taskListRef = useRef(null);

  useEffect(() => {
    getProjectTaskStatus();
    getProjectMembers();
  }, []);

  useEffect(() => {
    getTaskList();
  }, [assignedToFilter, priorityFilter]);

  const handleTaskView = (id) => {
    navigate(`/task-details/${id}`);
  };

  const handleOpenModal = (id) => {
    // let status;
    // if (id === '11') {
    //     status = "To do"
    // } else if (id === '12') {
    //     status = "In progress"
    // } else if (id === '13') {
    //     status = "To be verified"
    // } else if (id === '14') {
    //     status = "Completed"
    // } else {
    //     status = "To do"
    // }
    setTaskData({ ...taskData, status_id: id || columnTitles[0]?.id });
    setIsOpen(true);
  };

  const handleAddTask = () => {
    if (validator.isEmpty(taskData.title)) {
      errorNotification("Task title is required");
    } else {
      addTask(taskData);
      setIsOpen(false);
    }
  };

  const addTask = async (payload) => {
    try {
      const res = await postRequest(CREATE_TASK, payload, navigate);
      if (res.type === 1) {
        if (res.response.data.success) {
          getTaskList();
          setTaskData({
            title: "",
            assigned_to: null,
            assigned_by: null,
            due_date: null,
            priority: null,
            description: null,
            project_id: projectId,
            status: "To do",
          });
          successNotification(res.response.data.message);
        } else {
          errorNotification(res.response.data.message);
        }
      }
      if (res.type === 2) {
        errorNotification(res.errormessage || res.errors);
      }
    } catch (error) {
      errorNotification(error.message);
    }
  };

  const getProjectMembers = async () => {
    try {
      setFirstLoading(true);
      const res = await getRequest(
        `${GET_PROJECT_MEMBERS}?project_id=${projectId}`,
        null,
        navigate
      );
      if (res.data && res.data.data) {
        const dataList = res.data.data.map((item) => {
          return {
            value: item?.user.id,
            label:
              item?.user.first_name || item?.user.last_name
                ? item?.user.first_name + " " + item?.user.last_name
                : item?.user?.name || "--",
          };
        });
        setFilterMemberList(dataList);
        // dataList.unshift({ value: null, label: "None" });
        setMemberList(dataList);
      } else {
        errorNotification(res.errormessage);
        setMemberList([]);
      }
      setFirstLoading(false);
    } catch (error) {
      errorNotification(error);
      setFirstLoading(false);
    }
  };

  const getTaskList = async () => {
    try {
      // setFirstLoading(true);
      let apiUrl = `${GET_TASKS}?project_id=${projectId}`;
      if (assignedToFilter && assignedToFilter !== "All") {
        apiUrl += `&assigned_to=${assignedToFilter}`;
      }
      if (createdByFilter && createdByFilter !== "All") {
        apiUrl += `&assigned_by=${createdByFilter}`;
      }
      if (priorityFilter && priorityFilter !== "All") {
        apiUrl += `&priority=${priorityFilter}`;
      }
      const res = await getRequest(apiUrl, null, navigate);
      if (res.data && res.data.data) {
        setTaskList(res.data.data);
      } else {
        errorNotification(res.errormessage);
        setTaskList([]);
      }
      setFirstLoading(false);
    } catch (error) {
      errorNotification(error);
      setFirstLoading(false);
    }
  };

  const getProjectTaskStatus = async () => {
    try {
      // setFirstLoading(true);
      let apiUrl = `${GET_PROJECT_TASK_STATUS}?project_id=${projectId}`;

      const res = await getRequest(apiUrl, null, navigate);

      if (res.data && res.data.data) {
        // console.log("getProjectTaskStatus", res?.data?.data);
        setColumnTitles(res?.data?.data);
      }
    } catch (error) {
      errorNotification(error);
    }
  };

  const assignToFilterOption = [
    { label: "All", value: "All" },
    ...filterMemberList,
  ];

  const createdByFilterOption = [
    { label: "All", value: "All" },
    ...filterMemberList,
  ];

  const customFormatOptionLabel = ({ label, icon }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span style={{ marginRight: 10 }}>{icon}</span>
      <span>{label}</span>
    </div>
  );

  const customIcons = {
    Low: (
      <img
        src={low}
        alt="non urgent"
        style={{ width: "14px", height: "14px" }}
      />
    ),
    Medium: (
      <img
        src={normal}
        alt="important"
        style={{ width: "14px", height: "14px" }}
      />
    ),
    High: (
      <img src={high} alt="urgent" style={{ width: "14px", height: "14px" }} />
    ),
  };
  // const priorityOptionsList = ["Low", "Medium", "High"];
  const priorityOption = priorityOptions.map((props) => ({
    label: props,
    value: props,
    icon: customIcons[props],
  }));

  const priorityOptionWithNone = [
    {
      label: "All",
      value: "All",
    },
    ...priorityOption,
  ];

  const priorityFilterOption = priorityOptionWithNone.map((props) => props);

  // const createdByOption = createdByOption.map((props) => ({
  //   label: props,
  //   value: props,
  //   icon: customIcons[props],
  // }));

  // const createdByOptionWithNone = [
  //   {
  //     label: "All",
  //     value: "All",
  //   },
  //   ...createdByOption,
  // ];

  // const createdByFilterOption = createdByOptionWithNone.map((props) => props);

  const [showModal, setShowModal] = useState(false);
  const [deleteTaskId, setDeleteTackId] = useState(null);

  const handleDeleteTask = (id) => {
    if (id) {
      setDeleteTackId(id);
    } else {
      setDeleteTackId(null);
    }
    setShowModal(!showModal);
  };

  const confirmDelete = async () => {
    try {
      if (!deleteTaskId) {
        return;
      }
      let apiUrl = `${DELETE_TASK_BY_ID}?task_id=${deleteTaskId}`;
      const res = await deleteRequest(apiUrl, null, navigate);
      if (res?.type === 1) {
        await getTaskList();
        handleDeleteTask();
        successNotification(res.response.data.message);
      } else {
        errorNotification(res.errormessage);
        errorNotification(res.errormessage);
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleTaskComplete = async (id, is_completed) => {
    if (
      id == null ||
      is_completed == null ||
      id === undefined ||
      is_completed === undefined
    ) {
      return;
    }
    const payload = {
      task_id: id,
      is_completed: !is_completed,
    };
    try {
      const res = await patchRequest(`${UPDATE_TASK}`, payload, navigate);
      if (res?.response && res?.response.data.success) {
        // getTaskList();
      } else {
        // getTaskDetails();
        errorNotification(res?.errormessage);
      }
    } catch (error) {
      console.error(error);
      errorNotification(error);
    } finally {
      setFirstLoading(false);
    }
  };

  const handleTitleChange = async (newTitle) => {
    console.log(" handleTitleChange==> ", newTitle);
    try {
      const payload = {
        task_status_id: newTitle.id,
        title: newTitle.title,
      };
      const res = await patchRequest(
        `${UPDATE_PROJECT_TASK_STATUS}`,
        payload,
        navigate
      );
      if (res?.type === 1) {
        await getTaskList();
      }
    } catch (error) {
      console.log("error", error);
    }

    //API call to change title
  };

  const handleAddNewTitle = async (newTitle) => {
    console.log(" handleAddNewTitle==> ", newTitle);
    try {
      const payload = {
        project_id: projectId,
        title: newTitle,
      };
      const res = await postRequest(
        `${ADD_PROJECT_TASK_STATUS}`,
        payload,
        navigate
      );
      if (res?.type === 1) {
        await getProjectTaskStatus();
        await getTaskList();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDueDateChange = (newDate, formattedDate) => {
    setTaskData({
      ...taskData,
      due_date: formattedDate,
    });
  };

  const deleteStatus = async (id) => {
    try {
      const res = await deleteRequest(
        `${DELETE_PROJECT_TASK_STATUS}?task_status_id=${id}`,
        null,
        navigate
      );
      if (res?.type === 1) {
        await getProjectTaskStatus();
        await getTaskList();
      }
      if (res?.type === 2) {
        errorNotification(res?.errormessage);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleTitleIndexChange = async (updatedNames) => {
    try {
      const payload = {
        project_id: projectId,
        task_status_ids: updatedNames.map((item) => item.id),
      };
      const res = await patchRequest(
        `${MANAGE_PROJECT_TASK_STATUS_INDEX}`,
        payload,
        navigate
      );
      if (res?.type === 1) {
        setFirstLoading(true);
        await getProjectTaskStatus();
        await getTaskList();
        setIsDragPopupOpen(!isDragPopupOpen);
        setFirstLoading(false);
      }
    } catch (error) {
      console.error("Error updating task statuses Index:", error);
    }
  };

  return (
    <div className="hunter_audit_dashboard h-full flex flex-col">
      {firstLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="h-full flex flex-col px-2 pb-1 gap-2" ref={taskListRef}>
          <div className={`flex flex-row items-center px-2 justify-end`}>
            {/*   {role_access && (
          <button
            className="border-0 text-white rounded-md py-2.5 px-3.5 font-medium bg-[#267072]"
            onClick={() => handleOpenModal()}
          >
            + Add Task
          </button>
        )} */}
            <div className="px-4 flex justify-end items-end gap-4">
              {/* Change Status Index Button */}
              <Tooltip title="Change status Index">
                <button
                  onClick={() => setIsDragPopupOpen(!isDragPopupOpen)}
                  className="border border-[#cccccc] py-1 px-2 rounded-md h-9 w-10"
                >
                  <Configuration_icon />
                </button>
              </Tooltip>

              {isDragPopupOpen && (
                <DragPopup
                  isOpen={isDragPopupOpen}
                  setIsOpen={setIsDragPopupOpen}
                  columnTitles={columnTitles}
                  getProjectTaskStatus={getProjectTaskStatus}
                  getTaskList={getTaskList}
                  projectId={projectId}
                  setFirstLoading={setFirstLoading}
                  firstLoading={firstLoading}
                  handleTitleIndexChange={handleTitleIndexChange}
                />
              )}

              {/* Toggle View Button */}
              <Tooltip title={boardView ? "List view" : "Boards view"}>
                <button
                  onClick={() => setBoardView(!boardView)}
                  className="border border-[#cccccc] py-1 px-2 rounded-md h-9 w-10"
                >
                  {boardView ? <BoardIcon /> : <ListIcon />}
                </button>
              </Tooltip>

              {/* Created By Filter */}
              <div className="flex flex-col min-w-48">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Created By
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Created by"
                  name="Created by"
                  options={createdByFilterOption}
                  value={
                    createdByFilterOption.find(
                      (option) => option.value === createdByFilter
                    ) || createdByFilterOption[0]
                  }
                  onChange={(selectedOption) => {
                    const currentParams = Object.fromEntries(
                      searchParams.entries()
                    );
                    const updatedParams = {
                      ...currentParams,
                      pageno: 1,
                      assigned_by: selectedOption.value,
                    };
                    setSearchParams(new URLSearchParams(updatedParams));
                    setCreatedByFilter(selectedOption.value);
                  }}
                />
              </div>

              {/* Assigned To Filter */}
              <div className="flex flex-col min-w-48">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Assigned To
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Assign to"
                  name="Assign to"
                  options={assignToFilterOption}
                  value={
                    assignToFilterOption.find(
                      (option) => option.value === assignedToFilter
                    ) || assignToFilterOption[0]
                  }
                  onChange={(selectedOption) => {
                    const currentParams = Object.fromEntries(
                      searchParams.entries()
                    );
                    const updatedParams = {
                      ...currentParams,
                      pageno: 1,
                      assigned_to: selectedOption.value,
                    };
                    setSearchParams(new URLSearchParams(updatedParams));
                    setAssignedToFilter(selectedOption.value);
                  }}
                />
              </div>

              {/* Priority Filter */}
              <div className="flex flex-col min-w-36">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Priority
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Priority"
                  name="Priority"
                  options={priorityFilterOption}
                  value={priorityFilterOption.find(
                    (option) => option.value === priorityFilter
                  )}
                  onChange={(selectedOption) => {
                    const currentParams = Object.fromEntries(
                      searchParams.entries()
                    );
                    const updatedParams = {
                      ...currentParams,
                      pageno: 1,
                      priority: selectedOption.value,
                    };
                    setSearchParams(new URLSearchParams(updatedParams));
                    setPriorityFilter(selectedOption.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="grow overflow-y-auto">
            {boardView ? (
              <TaskListKanban
                projectId={projectId}
                taskList={taskList}
                handleTaskComplete={handleTaskComplete}
                getTasks={getTaskList}
                handleOpenModal={handleOpenModal}
                columnTitles={columnTitles}
                setColumnTitles={setColumnTitles}
                handleTitleChange={handleTitleChange}
                handleAddNewTitle={handleAddNewTitle}
                getProjectTaskStatus={getProjectTaskStatus}
                deleteStatus={deleteStatus}
                assignToFilterOption={assignToFilterOption}
                memberList={memberList}
                boardView={boardView}
              />
            ) : (
              <TaskListView
                projectId={projectId}
                handleTaskView={handleTaskView}
                handleTaskComplete={handleTaskComplete}
                taskList={taskList}
                getTasks={getTaskList}
                columnTitles={columnTitles}
                setColumnTitles={setColumnTitles}
                handleTitleChange={handleTitleChange}
                handleAddNewTitle={handleAddNewTitle}
                deleteStatus={deleteStatus}
                getProjectTaskStatus={getProjectTaskStatus}
                memberList={memberList}
                boardView={boardView}
              />
            )}
          </div>
          <Modal
            className="min-w-[60vw] task-modal"
            title="Add task"
            onClose={() => setIsOpen(false)}
            show={isOpen}
          >
            <div className="modal-body flex flex-col gap-4">
              <Row className="">
                <Col xs={12}>
                  <h6 className="mb-2">Task</h6>
                  <input
                    placeholder="Add Task"
                    className="h-10 w-full rounded-lg border !border-[#cfcbcb] p-[6px] "
                    type="text"
                    name="title"
                    value={taskData.title}
                    autoComplete="off"
                    onChange={(e) => {
                      setTaskData({
                        ...taskData,
                        title: e.target.value,
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={4}>
                  <h6 className="mb-2">Assignee to</h6>
                  <Select
                    className="rounded-lg text-capitalize"
                    options={memberList}
                    name="assignee to"
                    value={memberList.find(
                      (option) => option.value === taskData.assigned_id
                    )}
                    onChange={(selectedOption) =>
                      setTaskData({
                        ...taskData,
                        assigned_to: selectedOption
                          ? selectedOption.value
                          : null,
                      })
                    }
                  />
                </Col>
                <Col xs={4}>
                  <h6 className="mb-2">Priority</h6>
                  <Select
                    className="rounded-lg text-capitalize"
                    options={priorityOption}
                    formatOptionLabel={customFormatOptionLabel}
                    value={
                      taskData.priority
                        ? {
                            label: taskData.priority,
                            value: taskData.priority,
                            icon: customIcons[taskData.priority],
                          }
                        : null
                    }
                    onChange={(e) => {
                      setTaskData({
                        ...taskData,
                        priority: e.value,
                      });
                    }}
                  />
                </Col>
                <Col xs={4}>
                  <h6 className="mb-2">Due Date</h6>
                  {/* <input
                                placeholder="Due Date"
                                className="h-10 w-full rounded-lg border !border-[#cfcbcb] p-[6px] "
                                type="date"
                                name="due_date"
                                value={taskData.due_date}
                                autoComplete="off"
                                onChange={(e) => {
                                    setTaskData({
                                        ...taskData,
                                        due_date: e.target.value,
                                    });
                                }}
                            /> */}
                  <CommonDatePicker
                    value={taskData.due_date}
                    onChange={handleDueDateChange}
                    label="Due Date"
                    className="common-date-picker"
                    placeholder="Enter due date"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <h6 className="mb-2">Description</h6>
                  <textarea
                    placeholder="Add description"
                    className="w-full rounded-lg border !border-[#cfcbcb] p-[6px] min-h-40"
                    type="text"
                    name="task"
                    value={taskData.description}
                    onChange={(e) => {
                      setTaskData({
                        ...taskData,
                        description: e.target.value,
                      });
                    }}
                    autoComplete="off"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <button
                    className="border-0 text-white rounded-md py-2.5 px-3.5 font-medium bg-[#267072]"
                    onClick={handleAddTask}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            </div>
          </Modal>
          <NewModal
            title="Are you Sure?"
            onClose={() => setShowModal(false)}
            show={showModal}
          >
            <div className="modal-body add__cmp__form">
              <h6>Do you really want to delete this task?</h6>
              <div className="add__close__section">
                <button
                  type="button"
                  className="bg-[#F5F5F5] text-[#5D5D5D] w-[fit-content] px-4 py-2 rounded-[12px] me-3"
                  onClick={() => handleDeleteTask()}
                >
                  No
                </button>
                <button
                  type="button"
                  className="bg-[#267072] text-[#fff] border-[1px] flex items-center  w-[fit-content] px-3 py-2 rounded-[12px] whitespace-nowrap"
                  onClick={confirmDelete}
                >
                  Yes
                </button>
              </div>
            </div>
          </NewModal>
          <style>
            {`
                    .task-modal .modal-content{
                        overflow-y : unset;
                    }

                    .css-13cymwt-control{
                        border-color: var(--select-border);    
                    }
                `}
          </style>
        </div>
      )}
    </div>
  );
};

export default TaskList;
